import {Dialog, DialogBody, DialogHeader, IconButton} from "@material-tailwind/react";
import React, {Dispatch, SetStateAction} from "react";
import {Close} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {DocumentFile} from "../../../services/interface/DocumentFile";
import LoadingPage from "../LoadingPage";
export interface ModalFileProps {
    loading: boolean;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    file?: DocumentFile;
}

const ModalFile = ({
                       loading,
                       open,
                       setOpen,
                       file
                   }: ModalFileProps) => {
    const { t } = useTranslation("global") as { t: (key: string) => string }
    const [parsePdf, setParsePdf] = React.useState<any>();

    const closeDialog = () => {
        setOpen!(!open)
    }

    React.useEffect(() => {
        if (file && file.fileDocumentView && file?.typeFile?.includes('pdf')) {
            const fileBase64 = file?.fileDocumentView.replace('data:application/pdf;base64,', '')
            const byteCharacters = atob(fileBase64);
            const byteNumbers = new Array(byteCharacters.length).fill(null).map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const fileUrl = URL.createObjectURL(blob);
            setParsePdf(fileUrl);

            // Limpiamos el URL cuando el componente se desmonte
            return () => URL.revokeObjectURL(fileUrl);
        }
    }, [file]);

    return (
        <Dialog placeholder="dialog"  className='max-h-[80%] sm:max-h-[90%] overflow-y-auto fixed overflow-x-hidden min-w-[247.5px]' open={open} handler={() => {}} size={'xl'}>
            <DialogHeader placeholder="dialog-header"  className={'bg-headerColor rounded-t-[7px] border-b-[1px] border-b-gray-300'}>
                <div className={'grid grid-cols-2 w-full items-center'}>
                    <h3>{t('document')}</h3>
                    <div className={'flex justify-end'}>
                        <IconButton placeholder="icon-button"  variant="text" color="gray"
                                    onClick={() => {
                                        closeDialog()
                                    }}>
                            {
                                <Close className="w-5 text-gray-500" />
                            }
                        </IconButton>
                    </div>
                </div>
            </DialogHeader>
            <DialogBody placeholder="dialog-body"  className={'h-[452px] sm:h-[590px] mb-5 items-center'}>
                {loading ? <LoadingPage/> :
                    <>
                        {!loading && file && file?.typeFile?.includes('pdf') && parsePdf ?
                            <div className={'mx-2 h-full'}>
                                <embed src={parsePdf} type="application/pdf" width="100%" height="100%" />
                            </div>
                            : file?.fileDocumentView ?
                            <div className={'flex justify-center items-center mb-3'}>
                                <img src={file?.fileDocumentView} alt=""/>
                            </div> : <></>
                        }
                    </>
                }
            </DialogBody>
        </Dialog>
    )
}

export default ModalFile
